import { Member, MemberMap, MembersData } from '@nextforce/api'
import { useTheme } from '@rneui/themed'
import { useMembers } from 'chat/members/queries/list'
import { ReactorsScreenProps } from 'home/stack/types'
import React, { useLayoutEffect } from 'react'
import { StatusBoundary } from 'shared/components/status_boundary'
import { showHeaderButton } from 'shared/header/header_button'
import { useNonDeletedMessages } from '../queries/list'
import { ReactorsView } from './view'

export function ReactorsScreen({ navigation, route }: ReactorsScreenProps) {
  const { theme } = useTheme()
  const { conversationId, messageId, emoji } = route.params

  const {
    data: currentMessage,
    isLoading: isMessagesLoading,
    error: messagesError,
  } = useNonDeletedMessages(data =>
    data.messages.find(
      m => m.conversationId === conversationId && m.id === messageId
    )
  )

  useLayoutEffect(() => {
    showHeaderButton({
      navigation,
      theme,
      title: 'close',
      onPress: () => {
        navigation.goBack()
      },
      position: 'right',
      useIcon: true,
    })
  }, [navigation, theme])

  const members = useMembers(conversationId)

  const memberMap = (members.data as MembersData)?.reduce<MemberMap>(
    (map, member) => ({ ...map, [member.id]: member }),
    {}
  )

  const reactorIds = currentMessage?.reactions.flatMap(r => {
    if (r.emoji === emoji) {
      return r.userId
    }

    return []
  })

  const reactorsList =
    reactorIds?.flatMap<Member>(id => getReactor(id, memberMap) ?? []) ?? []

  return (
    <StatusBoundary isLoading={isMessagesLoading} error={messagesError}>
      <ReactorsView reactors={reactorsList} />
    </StatusBoundary>
  )
}

function getReactor(id: string, memberMap: MemberMap): Member | undefined {
  const member = memberMap?.[id]

  if (member) {
    return member
  }
}
